<template>
  <media-selector-dialog
    :visible="visible"
    media-type="video"
    upload-accept=".mp4"
    source-selection
    :upload-handler="upload"
    :confirm-handler="confirm"
    @update:visible="$emit('update:visible', $event)"
    @tab-change="tabChanged">
    <template #library>
      <el-select v-model="shopId" :disabled="busy" placeholder="选择来源店铺" @change="resetLibrary">
        <el-option
          v-for="shop in shops"
          :key="shop.mer_shop_id"
          :value="Number(shop.mer_shop_id)"
          :label="shop.shop_name" />
      </el-select>
      <div class="folder-path">
        <button
          v-for="(folder, index) in path"
          :key="folder.id"
          :disabled="busy || loading"
          @click="navigate(index)">
          {{ folder.name }} /
        </button>
      </div>
      <p v-if="error" class="error">
        {{ error }}
        <el-button type="text" @click="load(page)">重新加载</el-button>
      </p>
      <div v-loading="loading" class="material-grid">
        <button
          v-for="folder in folders"
          :key="'folder-' + folder.folder_id"
          class="material"
          :disabled="busy"
          @click="enter(folder)">
          <i class="el-icon-folder"></i>
          <span>{{ folder.name || folder.folder_name || '文件夹' }}</span>
        </button>
        <button
          v-for="item in videos"
          :key="String(item.material_id)"
          class="material"
          :class="{ selected: selectedId === String(item.material_id) }"
          :disabled="busy || Number(item.audit_status) !== 3"
          @click="select(item)">
          <img
            v-if="item.video_info && item.video_info.video_cover_url"
            :src="item.video_info.video_cover_url"
            alt="视频封面" />
          <i v-else class="el-icon-video-camera"></i>
          <span>{{ item.name || item.materil_name || '未命名视频' }}</span>
          <small>{{ auditLabel(item.audit_status) }}</small>
        </button>
      </div>
      <p v-if="!loading && !error && !folders.length && !videos.length">当前目录暂无视频</p>
      <el-pagination
        :current-page="page"
        :page-size="20"
        :total="total"
        layout="prev, pager, next"
        @current-change="load" />
    </template>
  </media-selector-dialog>
</template>
<script>
import MediaSelectorDialog from '@/components/MediaSelectorDialog.vue'
import {
  uploadDoudianMainVideoSource,
  registerDoudianMainVideoSource,
  getDoudianMainVideoFolders,
  getDoudianMainVideoMaterials
} from '@/api/main/doudianBatchEdit'
const key = () => 'video-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)
export default {
  name: 'DoudianVideoSelectorDialog',
  components: { MediaSelectorDialog },
  props: { visible: Boolean, shops: { type: Array, default: () => [] } },
  data: () => ({
    shopId: null,
    path: [{ id: '2', name: '我的视频' }],
    folders: [],
    videos: [],
    page: 1,
    total: 0,
    selectedId: '',
    uploadInput: null,
    libraryInput: null,
    busy: false,
    loading: false,
    libraryLoaded: false,
    error: '',
    sequence: 0
  }),
  watch: {
    visible(value) {
      this.sequence++
      this.loading = false
      if (value) {
        this.uploadInput = null
        this.libraryInput = null
        this.selectedId = ''
        this.folders = []
        this.videos = []
        this.libraryLoaded = false
        this.shopId = this.shops[0] ? Number(this.shops[0].mer_shop_id) : null
        this.path = [{ id: '2', name: '我的视频' }]
      }
    }
  },
  beforeDestroy() {
    this.sequence++
  },
  methods: {
    tabChanged(tab) {
      if (tab === 'library' && !this.libraryLoaded) this.load(1)
    },
    resetLibrary() {
      this.path = [{ id: '2', name: '我的视频' }]
      this.selectedId = ''
      this.libraryInput = null
      this.folders = []
      this.videos = []
      this.load(1)
    },
    enter(folder) {
      this.path.push({ id: String(folder.folder_id), name: folder.name || folder.folder_name || '文件夹' })
      this.load(1)
    },
    navigate(index) {
      this.path = this.path.slice(0, index + 1)
      this.load(1)
    },
    async load(page = 1) {
      if (!this.shopId) return
      const seq = ++this.sequence
      this.loading = true
      this.error = ''
      this.selectedId = ''
      this.libraryInput = null
      const data = { shop_id: this.shopId, folder_id: this.path[this.path.length - 1].id, page, limit: 20 }
      try {
        const [folderRes, videoRes] = await Promise.all([
          getDoudianMainVideoFolders(data),
          getDoudianMainVideoMaterials(data)
        ])
        if (seq !== this.sequence || !this.visible) return
        this.folders = folderRes.data?.folder_info_list || []
        const info = videoRes.data?.folder_info || {}
        this.videos = (info.child_material || []).filter((item) => item.material_type === 'video')
        this.total = Number(info.total_child_material_num || 0)
        this.page = page
        this.libraryLoaded = true
      } catch (error) {
        if (seq === this.sequence) {
          this.error = error.message || '视频素材加载失败'
          this.folders = []
          this.videos = []
        }
      } finally {
        if (seq === this.sequence) this.loading = false
      }
    },
    select(item) {
      this.selectedId = String(item.material_id)
      this.libraryInput = {
        source_kind: 'library',
        request_key: key(),
        source_shop_id: this.shopId,
        material_id: this.selectedId,
        name: Array.from(String(item.name || item.materil_name || '视频素材.mp4'))
          .slice(0, 50)
          .join('')
      }
    },
    auditLabel(value) {
      return { 0: '下载中', 1: '待审核', 2: '审核中', 3: '审核通过', 4: '审核拒绝' }[value] || '状态待核验'
    },
    async upload(file, options) {
      const data = await uploadDoudianMainVideoSource(file, options)
      return { ...data, object_name: file.name }
    },
    async confirm({ tab, sources }) {
      let input = this.libraryInput
      if (tab === 'upload') {
        const source = sources[0]
        if (!source?.upload_data?.storage_path) throw new Error('请先上传视频')
        if (this.uploadInput?.request_key !== source.client_key)
          this.uploadInput = {
            source_kind: 'upload',
            request_key: source.client_key,
            object_key: source.upload_data.storage_path,
            name: Array.from(String(source.upload_data.object_name || '视频.mp4'))
              .slice(0, 50)
              .join('')
          }
        input = this.uploadInput
      }
      if (!input || this.loading) throw new Error('请选择审核通过的视频')
      this.busy = true
      try {
        const res = await registerDoudianMainVideoSource(input)
        this.$emit('selected', res.data)
      } finally {
        this.busy = false
      }
    }
  }
}
</script>
<style scoped>
.material-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  min-height: 120px;
  margin: 12px 0;
}
.material {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px;
  border: 1px solid #dce3ef;
  border-radius: 6px;
  background: white;
  min-width: 0;
  cursor: pointer;
}
.material.selected {
  border-color: #1677ff;
  background: #f0f7ff;
}
.material img {
  width: 100%;
  height: 90px;
  object-fit: contain;
}
.material i {
  font-size: 32px;
  color: #8190a7;
}
.material span {
  overflow-wrap: anywhere;
}
.material:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.folder-path {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 12px;
}
.folder-path button {
  background: none;
  border: 0;
  color: #1677ff;
  cursor: pointer;
}
.error {
  color: #d33;
}
</style>
